/**
 * ----------------------------------------------------------------------------------------------
 * individual JS for TOP Page
 * ----------------------------------------------------------------------------------------------
 */

// Header: SNSアカウントのカラー管理
window.addEventListener("scroll", () => {
  const sns_elem = document.querySelector(".c-Header__Social");
  const scroll = window.pageYOffset;
  if (sns_elem && scroll > 0) {
    sns_elem.style.setProperty("color","var(--heading-color)")
  } else if(sns_elem && scroll === 0) {
    sns_elem.style.setProperty("color","#FFFFFF")
  }
});